<section class="content">
  <div class="container-fluid">
    <div *ngIf="!is_counter_selected">
      <div class="card" style="    padding: 24px;">
        <div style="margin-top: 2%;">
          <label style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">Select the counter you
            are going to work today</label>
        </div>
        <div class="row">
          <div class="col-sm-12 col-lg-7 col-md-7">
            <div class="row">
              <div class="border-item col-4" style="font-weight: bold;">Collection Center</div>
              <div class="border-item col-4" style="font-weight: bold;">Counter Name</div>
              <div class="border-item col-4" style="font-weight: bold;">Login users</div>
            </div>
            <div class="row" *ngFor="let center of collection_center">
              <div class="border-item col-4">{{center}}</div>
              <div class="col border-item">
                <div class="row" *ngFor="let counter of counter_list[center]">
                  <div class="col border-item"><button mat-button
                      style="background: aquamarine; border-radius: 15px; margin-top: 10px;"
                      (click)="counterClicked(counter.counter_id)"
                      [disabled]="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">{{counter['counter_name']}}</button>
                  </div>
                  <div class="col border-item">
                    <span *ngIf="logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                      {{logged_user_befere_select_counter[counter.counter_id]['employee_name']}} at
                      {{logged_user_befere_select_counter[counter.counter_id]['start_date_time'] | date: 'shortTime'}}
                    </span>
                    <span *ngIf="!logged_user_befere_select_counter.hasOwnProperty(counter.counter_id)">
                      No one
                    </span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div *ngIf="counter_ids">
      <label style="font-size: 22px; margin-left: 45%">Wallet balance ₹
      </label>
      <div class="center" style=" margin: auto; width: 11%; border: 3px solid black;border-radius: 18px;
      height: 88px;">
        <h4 class="line1" style=" margin-top: 14%;">{{payment}}</h4><br><br>
      </div>
    </div> -->
    <div *ngIf="is_counter_selected">
      <!-- search booth code -->
      <div class="form-row" style="margin-top: 10%; margin-left: 8%;" *ngIf="!is_business_selected">
        <div class="col-sm-6 col-lg-3 col-md-3">
          <label style="font-size: 15px;">Enter Booth Code and Search <i class="material-icons"
              style="color: red;font-size: 14px;">star</i></label>
          <input type="number" class="form-control" (keydown.enter)="getBusinessLastSale()" id="booth_number"
            style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;"
            [(ngModel)]="selected_business_code">
        </div>
        <div class="col-sm-6 col-lg-2 col-md-2" style="margin-left: 12px; margin-top: 4%;">
          <button mat-raised-button color="primary" (click)="getBusinessLastSale()" class="button-class"
            style="font-size: 20px; height: 40px;" [disabled]="selected_business_code == null">Search</button>
        </div>
      </div>
      <div *ngIf="counter_ids" style="    margin-right: 48%;
      margin-bottom: 1%;">
        <label style="font-size: 22px;
        margin-left: 40%">Wallet balance ₹
        </label>
        <div class="center" style=" margin: auto;
        width: 24%;
        border: 2px solid black;
        border-radius: 12px;
        height: 73px;">
          <h4 class="line1" style=" margin-top: 14%;">{{wallet_amount['business_wallet_balance']}}</h4><br><br>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-sm-12">
          <div *ngIf="is_business_selected && show_order_table">
            <!-- new order -->
            <div class="card" class="main-card" style="margin-bottom: 15px;"
              *ngFor="let date of order_date_list; let form_index= index; let last_index=last; let first_index=first;">
              <span *ngIf="selected_index === form_index">
                <span *ngIf="product_form_dict.hasOwnProperty(date)">
                  <!-- Product Group Limits Display -->
                  <div *ngFor="let groupId of [1, 2, 3]">
                    <div *ngIf="hasWholeDayLimits(groupId)" style="font-size: smaller; margin: 10px 0;">
                      <div style="display: inline-flex; font-size: small; width: 100%;">
                        <div style="min-width: 120px;">
                          <ng-container [ngSwitch]="groupId">
                            <ng-container *ngSwitchCase="1">Milk Limit:</ng-container>
                            <ng-container *ngSwitchCase="2">Fermented Products Limit:</ng-container>
                            <ng-container *ngSwitchCase="3">Loose Milk Limit:</ng-container>
                          </ng-container>
                        </div>
                        <div [style.color]="getGroupLimitColor(groupId)">
                          {{(productGroupTotals[groupId] || 0) | number:'1.1-1'}}L
                        </div>
                        <div class="col-1" style="padding: 0px 10px 0px 6px;"
                          *ngIf="getWholeDayLimit(groupId)?.min_litre !== null || getWholeDayLimit(groupId)?.max_litre !== null">
                          |</div>
                        <ng-container *ngIf="getWholeDayLimit(groupId)?.min_litre !== null">
                          <div>{{getWholeDayLimit(groupId)?.min_litre}}L <span style="font-size: xx-small;">(min)</span>
                          </div>
                        </ng-container>
                        <div
                          *ngIf="getWholeDayLimit(groupId)?.min_litre !== null && getWholeDayLimit(groupId)?.max_litre !== null"
                          class="col-1" style="padding: 0px 10px 0px 6px;">|</div>
                        <div *ngIf="getWholeDayLimit(groupId)?.max_litre !== null">
                          {{getWholeDayLimit(groupId)?.max_litre}}L <span style="font-size: xx-small;">(max)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="text-align: center; font-size: 20px;">
                    <div class="col-3"></div>
                    <div class="col-2" *ngFor="let session of session_list">
                      <span *ngIf="session.id ==1">
                        Mor
                      </span>
                      <span *ngIf="session.id ==2">
                        Eve
                      </span>
                    </div>
                    <div class="col" style="max-width: 120px; text-align: right;">
                      <label style="font-size: 20px;">Price</label>
                    </div>
                  </div>

                  <!-- Session limits display -->
                  <ng-container *ngFor="let groupId of [1, 2, 3]">
                    <ng-container *ngIf="hasSessionLimits(groupId)">
                      <div class="row align-items-center" style="margin: 4px 0;">
                        <div class="col-3"></div>
                        <div class="col-2" *ngFor="let session of session_list">
                          <div style="display: flex; flex-direction: column; align-items: center;">
                            <div [style.color]="getSessionLimitColor(groupId, session.id)" style="white-space: nowrap;">
                              {{getSessionCurrent(groupId, session.id) | number:'1.1-1'}}L
                              <span style="font-size: 12px;">(cur)</span>
                            </div>
                            <ng-container *ngIf="getSessionMin(groupId, session.id) !== null">
                              <div style="white-space: nowrap; color: #666;">
                                {{getSessionMin(groupId, session.id)}}L
                                <span style="font-size: 12px;">(min)</span>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="getSessionMax(groupId, session.id) !== null">
                              <div style="white-space: nowrap; color: #666;">
                                {{getSessionMax(groupId, session.id)}}L
                                <span style="font-size: 12px;">(max)</span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        <div class="col"></div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <span *ngFor="let product of product_list; let product_index=index">
                    <div class="row">
                      <div class="col-12"
                        *ngIf="product_groupby_list[product.product_group_id][0] === product.product_id">
                        <hr style="background-color: #fff4f4; width: 100%;" *ngIf="product.product_group_id !== 1"
                          style="width: 88%;">
                      </div>
                      <div class="col-3" style="font-size: 14px;">
                        {{product.product_short_name}}
                        <div style="font-size: 12px; font-style: italic; color: gray;"
                          *ngIf="product.product_group_id !== 3">
                          {{product.product_mrp | currency:'INR'}}
                        </div>
                        <div style="font-size: 12px; font-style: italic; color: #e83e8c;"
                          *ngIf="min_max_limit_dict?.min_max_product_limit && min_max_limit_dict.min_max_product_limit[product.product_id] && (min_max_limit_dict.min_max_product_limit[product.product_id].min_packet !== null || min_max_limit_dict.min_max_product_limit[product.product_id].max_packet !== null)">
                          <ng-container
                            *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].min_packet !== null">
                            Min:
                            {{min_max_limit_dict.min_max_product_limit[product.product_id].min_packet}}
                            packets
                            <span
                              *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].is_per_session">/session</span>
                          </ng-container>
                          <ng-container
                            *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].max_packet !== null">
                            <br>Max:
                            {{min_max_limit_dict.min_max_product_limit[product.product_id].max_packet}}
                            packets
                            <span
                              *ngIf="min_max_limit_dict.min_max_product_limit[product.product_id].is_per_session">/session</span>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-2" *ngFor="let session of session_list" style="margin-right: 2%;">
                        <input type="tel" style="border: 1px solid; padding: 2px;  height: 30px;" placeholder="0"
                          [min]="0" id="{{session.id}}_{{product_index}}"
                          (keyup)="eventEmitOnInput(session.id, product_index, date, $event)"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          [(ngModel)]="product_form_dict[date]['product'][session.id][product.product_id]['quantity']"
                          (ngModelChange)="productQuantityChanged(date, session.id, product.product_id, product.product_mrp, product_index, product.product_quantity)"
                          [disabled]="checkExpiry(date,session, product)" [style.border-color]="product.color"
                          [style.background]="checkExpiry(date,session, product) ? 'lightgray': 'none'">
                      </div>
                      <div class="col" style="max-width: 120px; text-align: right; margin-top: 10px;">
                        <label style="font-size: 17px;">
                          {{product_form_dict[date]['total_price_per_product'][product.product_id] |
                          currency:'INR'}}</label>
                      </div>
                    </div>
                    <div class="row" *ngIf="product.product_group_id == 3 && business_type_id == 11"
                      (click)="openLooseMilkCard()" style="cursor: pointer;">
                      <div class="col-12"
                        *ngIf="product_groupby_list[product.product_group_id][0] === product.product_id">
                        <hr style="background-color: #fff4f4; width: 100%;" style="width: 88%;">
                      </div>
                      <div class="col-6"
                        *ngIf="product_groupby_list[product.product_group_id][0] === product.product_id">
                        <label>Loose Can milk <span
                            [style.color]="enable_minimum_warning_for_loose_milk ? 'red': 'black'">Minimum quanity is
                            {{product['minimum_quantity']}}</span></label>
                      </div>
                      <div style="text-align: right;" class="col-6"
                        *ngIf="product_groupby_list[product.product_group_id][0] === product.product_id">
                        <i class="material-icons" *ngIf="!enable_loose_milk_card"
                          style="font-size: 25px; background: aquamarine;">
                          expand_more
                        </i>
                        <i class="material-icons" *ngIf="enable_loose_milk_card"
                          style="font-size: 25px; background: aquamarine;">
                          expand_less
                        </i>
                      </div>
                    </div>
                    <div class="row"
                      *ngIf="enable_loose_milk_card && product.product_group_id == 3 && business_type_id == 11">
                      <div class="col-1"></div>
                      <div class="col-3" style="font-size: 14px;">
                        {{product.product_short_name}}<br>
                        <div style="font-size: 12px; font-style: italic; color: gray;"
                          *ngIf="product.product_group_id !== 3">
                          {{product.product_mrp | currency:'INR'}}</div>
                        <div style="font-size: 12px; font-style: italic; color: gray;"
                          *ngIf="product.product_group_id == 3">
                          <div *ngFor="let variation_product of product_quantity_variation_list[product.product_id]">
                            {{variation_product['min_quantity']}} <span
                              *ngIf="variation_product['max_quantity'] <= 1000">
                              to 1000</span>
                            <span *ngIf="variation_product['max_quantity'] > 1000"> & above</span> -
                            {{variation_product['mrp'] | currency: 'INR'}}
                          </div>
                        </div>
                        <!-- <span style="font-size: 12px;font-style: italic">₹ {{product.product_mrp | number:'1.0-4'}}</span> -->
                      </div>
                      <div class="col-2" *ngFor="let session of session_list" style="margin-right: 2%;">
                        <input type="tel" style="border: 1px solid; padding: 2px; height: 30px;" placeholder="0"
                          [min]="0" id="{{session.id}}_{{product_index}}"
                          (keyup)="eventEmitOnInput(session.id, product_index, date, $event)"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          [(ngModel)]="product_form_dict[date]['product'][session.id][product.product_id]['quantity']"
                          (ngModelChange)="productQuantityChanged(date, session.id, product.product_id, product.product_mrp, product_index, product.product_quantity)"
                          [disabled]="checkExpiry(date,session, product)" [style.border-color]="product.color"
                          [style.background]="checkExpiry(date,session, product) ? 'lightgray': 'none'">
                      </div>
                      <div class="col" style="max-width: 120px; text-align: right; margin-top: 10px;">
                        <label style="font-size: 17px;">
                          {{product_form_dict[date]['total_price_per_product'][product.product_id] |
                          currency:'INR'}}</label>
                      </div>
                    </div>
                  </span>
                  <!-- <div class="row" style="font-size: 25px;">
                    <div class="col-8" style="text-align: right;">
                      <label style="font-size: 20px;">Total price</label>
                    </div>
                    <div class="col-4"
                      style="text-align: right;max-width: 150px; border-top: 1px solid; border-bottom: 1px solid;">
                      <label style="font-size: 17px;">
                        {{product_form_dict[date]['total_price_per_date'] | currency:'INR'}}
                      </label>
                    </div>
                  </div> -->
                </span>
              </span>
            </div>
            <!-- Confirm Order Button -->
            <div class="row" style="margin-top: 20px;" *ngIf="is_business_selected && show_order_table">
              <div class="col-8" style="text-align: right;">
                <label style="font-size: 20px;">Total: {{final_price | currency:'INR'}}</label>
              </div>
              <div class="col-4" style="text-align: right;">
                <button mat-raised-button color="primary" (click)="confirmCliked()" id="confirm_button"
                  class="button-class" style="font-size: 18px; height: 45px;" [disabled]="checkConfirmButtonValid()">
                  Confirm Order
                </button>
              </div>
            </div>
            <!-- <div class="row" style="margin-top: 23px;">
              <div class="col"></div>
              <div class="col-4" style="text-align: right;">
                <button mat-raised-button (click)="addNewFormClicked()" class="button-class"
                  [disabled]="final_price == 0 || enable_minimum_warning_for_loose_milk">
                  New Order <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
                </button>
              </div>
            </div> -->
          </div>
          <div class="card" *ngIf="!show_order_table" style="padding: 20px; color: blue;">
            <h1>{{ future_order_alert_content }}</h1>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <div class="form-row" *ngIf="is_business_selected">

            <div class="col">
              <label style="font-size: 15px;">Enter Booth Code and Search <i class="material-icons"
                  style="color: red;font-size: 14px;">star</i></label>
              <input type="number" class="form-control" (keydown.enter)="getBusinessLastSale()" id="booth_number"
                data-date-inline-picker="true"
                style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;font-size: 20px;"
                [(ngModel)]="selected_business_code">
            </div>
            <div class="col-3" style="margin-left: 12px; margin-top: 8%">
              <button mat-raised-button color="primary" (click)="getBusinessLastSale()" class="button-class"
                style="font-size: 20px;" [disabled]="selected_business_code == null">Search</button>
            </div>
          </div>
          <div class="row" *ngIf="is_business_selected">
            <div class="col">
              <!-- ({{booth_details['agent_code']}})  -->
              {{booth_details['agent_name'] }}
            </div>
            <div class="col-4">
              <b>Booth Code:</b> {{booth_details['booth_code']}}
            </div>
            <div class="col-4">
              {{booth_details['booth_zone']}} Zone
            </div>
          </div>
          <div class="row" *ngIf="is_business_selected">
            <div class="col-3">
              {{booth_details['agent_mobile']}}
            </div>
            <div class="col">
              Mor Route - {{booth_details['mor_route_name'] | slice: 0: -4}}
            </div>
            <div class="col">
              Eve Route - {{booth_details['eve_route_name'] | slice: 0: -4}}
            </div>
            <!-- <div class="col">
              {{ booth_details['booth_address']}}
            </div> -->
          </div>
          <!-- <div class="card" style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px; background: #fff8ed;"
            *ngIf="is_business_selected">
            <div class="row" style="margin-bottom: -10px !important;">
              <div class="col-5">
                <h5 style="font-weight: normal;">Booth Details</h5>
              </div>
              <div class="col" style="text-align: right; font-size: 15px;">
                <b>Wallet:</b> {{booth_details['wallet_amount'] | currency: 'INR'}}
              </div>
            </div>
            <hr style="background: lightgray;">

          </div> -->
          <div style="background: #efeeec; padding: 10px; color: gray;overflow: auto;  height: 600px;">
            <div class="row">
              <div class="col" style="text-align: center; font-size: 22px;">
                {{counter_name}} , {{today_date_time | date: 'EEEE, MMM d'}}<br>
              </div>
            </div>
            <div class="row" style="font-size: 18px;">
              <div class="col" style="text-align: center;">
                Total : {{total_amount_in_counter | currency: 'INR'}}
              </div>
              <div class="col-4">
                {{total_booth_count}} Ordered
              </div>
              <div class="col-3">
                <button mat-button (click)="openZoneWiseCountCliked()" class="button-class"
                  style="font-size: small; height: 30px;">Pending</button>
              </div>
            </div>
            <hr style="background: white;">
            <div class="row" style="font-size: 20px; color: #6fbebe; margin-left: 0%;">
              <!-- <div class="col-1"></div> -->
              <div class="col-4">B. code</div>
              <!-- <div class="col-2">Name</div> -->
              <div class="col-3">Amount</div>
              <div class="col-5">Ord.time</div>
            </div>
            <div class="row" *ngFor="let user of login_users" style="font-size: 15px;">
              <div class="col-12" style="margin-bottom: 10px;">
                <div class="row">
                  <div class="col"><span style="font-weight: bold;">{{user['employee_name']}}</span><span
                      style="font-style: italic;">
                      ({{user['login_time']| date: 'shortTime'}} to <span
                        *ngIf="user.logout_time != 0 ">{{user['logout_time'] | date: 'shortTime'}}</span><span
                        *ngIf="user.logout_time == 0 ">Now</span> )
                    </span></div>
                </div>
              </div>
              <div class="col-12">
                <span *ngIf="sale_group_data.hasOwnProperty(user.login_id)">
                  <div class="row" *ngFor="let sale_data of sale_group_data[user.login_id]; let index=index"
                    style="margin-bottom: 10px !important; color: #6fbebe; margin-left: 0%;">
                    <!-- <div class="col-1"></div> -->
                    <div class="col-4">{{index + 1}}. {{sale_data['business_code']}} &nbsp; &nbsp;<span
                        style="font-style: italic;">{{sale_data['date']| date: 'MMM, d'}}</span></div>
                    <!-- <div class="col-2">{{sale_data['agent_first_name'] | slice : 0:6 }}</div> -->
                    <div class="col-3" style="text-align: right!important;">
                      {{sale_data['total_price_per_date'] | currency: 'INR'}}</div>
                    <div class="col-3">{{sale_data['order_created_time'] | date: 'shortTime'}}
                    </div>
                    <div class="col-2">
                      <i style="cursor: pointer;" class="material-icons"
                        (click)="editViaCounterCliked(sale_data['date'], sale_data['business_code'], sale_data['business_type_id'])">create</i>
                    </div>
                  </div>
                </span>
                <div *ngIf="!sale_group_data.hasOwnProperty(user.login_id)"
                  style="text-align: center; margin-bottom: 10px;">No booth order till now</div>
              </div>
              <div class="col-12">
                <hr style="background: white;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="is_business_selected">
      <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h4>Order History</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let date of future_order_date_list"
              style="margin-top: 6px; margin-bottom: 15px; border-radius: 8px;">
              <mat-expansion-panel-header style="padding: 30px;">
                <mat-panel-title>
                  {{ date | date: 'EEEE, MMM d' }}
                </mat-panel-title>
                <mat-panel-description style="text-align: right!important;">
                  {{ one_week_order_details[date]['per_date'] | currency:'INR'}}
                  <div style="margin-left: 50%;" *ngIf="employee_user_type_id != 2 ">
                    <button mat-button class="button-class" (click)="editClicked(date)"
                      *ngIf="checkEnableEditButton(date)">Edit</button>
                  </div>
                  <div style="margin-left: 50%;" *ngIf="employee_user_type_id == 2 ">
                    <button mat-button class="button-class" (click)="editClicked(date)">Edit</button>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-4"></div>
                <div class="col-2" *ngFor="let session of session_list">
                  {{session['display_name']}}
                </div>
                <div class="col">Price</div>
              </div>
              <div class="row" *ngFor="let product of product_list">
                <div class="col-4">{{product['product_short_name']}}</div>
                <div class="col-2" *ngFor="let session of session_list">
                  <label>
                    {{one_week_order_details[date]['session'][session.id]['product'][product.product_id]}}</label>
                </div>
                <div class="col">{{one_week_order_details[date]['per_product'][product.product_id] | currency:'INR'}}
                </div>
              </div>
              <hr style="background: lightgray;">
              <div>Order have been taken at <b>{{one_week_order_details[date]['counter_name']}}</b></div>
              <div class="row" style="text-align: center;">
                <div class="col-2"></div>
                <div class="col">Order by </div>
                <div class="col"> Modified by</div>
              </div>
              <div class="row" *ngFor="let session of session_list" style="text-align: center;">
                <div class="col-2">{{session['display_name']}}</div>
                <div class="col">
                  <span
                    *ngIf="one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_created'] !== null">
                    {{one_week_order_details[date]['session'][session.id]['order_date_and_time']['ordered_by']}} @
                    {{one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_created'] | date:
                    'MMM d, y, h:mm a'}}
                  </span>
                  <span
                    *ngIf="one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_created'] == null">
                    -
                  </span>
                </div>
                <div class="col">
                  <span
                    *ngIf="one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_modified'] !== null">
                    {{one_week_order_details[date]['session'][session.id]['order_date_and_time']['modified_by']}} @
                    {{one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_modified'] |
                    date: 'MMM d, y, h:mm a'}}
                  </span>
                  <span
                    *ngIf="one_week_order_details[date]['session'][session.id]['order_date_and_time']['time_modified'] == null">
                    -
                  </span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>